import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UrlsService } from '../../../Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { HttpErrorResponse } from '@angular/common/http';
import { EmitterService } from '../../../Shared/Services/emitter.service';
import {MatSort, MatSortModule} from '@angular/material/sort';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner'
import {MatCell, MatColumnDef, MatHeaderCell, MatHeaderRow, MatRow, MatTableDataSource, MatTableModule} from '@angular/material/table'
import { map, Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import $ from 'jquery';

@Component({
    selector: 'app-system-log-summary',
    imports: [MatSortModule, MatPaginatorModule, MatRow, MatHeaderRow, MatCell, MatHeaderCell, MatColumnDef, MatTableModule, MatProgressSpinnerModule],
    templateUrl: './system-log-summary.component.html',
    styleUrls: ['./system-log-summary.component.scss']
})
export class SystemlogsummaryComponent implements OnInit, OnDestroy {
  @ViewChild(MatSort)
  sort!: MatSort;
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  displayedColumns = ["time", "event_Description"];
  firstNumber: any = "";
  firstDescription: any;
  isLoadingResults = true;
  isRateLimitReached = false;
  dataSource = new MatTableDataSource();
  currentdate = new Date();
  formatedDate: any;
  rowcount: any = 50;
  subscription!: Subscription;
  constructor(
    private datePipe: DatePipe,
    private UrlsService: UrlsService,
    private UserService: UserService,
    private SharedHttpClientService: SharedHttpClientService,
    private EmitterService: EmitterService) {

  }
  /*** date formate change ***/
  transformDateFormatt(date: any) {
    return this.UserService.getyyyyMMddDateFormate(date);
  }

  loadSummaryLogData() {
    this.isLoadingResults = true;
    this.SharedHttpClientService.get(
      this.UrlsService.setAPIURl2(
        APIURL.MD_System_log_summary,
        this.UserService.getActiveMPID(),
        this.formatedDate))
      .pipe(map((response: Response) => {
        this.isLoadingResults = false;
        this.isRateLimitReached = false;
        return response;
      }))
      .subscribe({
        next: (Element: any) => {
          this.dataSource.data = Element;
          this.firstNumber = Element[0].time;
          this.firstDescription = Element[0].event_Description;
          if (Element != null || Element != "") {
            let Totalcount = Object.keys(Element).length;
            localStorage.setItem('nasdaqlisted', "N");
            localStorage.setItem("SOD", "N");
            localStorage.setItem("otclist", "N");
            localStorage.setItem("otherlisted", "N");
            for (let i = 0; i < Totalcount; i++) {
              let Remark: any = Element[i].event_Description;
              let yes: string = "Y";
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
        }
      });  
  }

  ngOnInit() {
    this.formatedDate = this.transformDateFormatt(this.currentdate);
    this.loadSummaryLogData();
    this.subscription = this.EmitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.loadSummaryLogData();
      }
    });

  }

  ngAfterViewInit() {
    /* reload log after 5 min */
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }
  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
}